import React, { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import * as S from './styles';

interface DetailsSectionProps {
  title: string;
  notice?: string | ReactNode;
  children: string | ReactNode;
  headerItem?: ReactNode | string;
  testId?: string;
  selectedOfferId: string;
}

const DetailsSection: React.FC<DetailsSectionProps> = ({
  testId = 'details-section',
  title,
  notice,
  children,
  headerItem,
  selectedOfferId,
}) => (
  <Grid container component="section" data-testid={testId} m={0}>
    <S.DetailsSection xs={12} lg={selectedOfferId ? 8 : 12} m={0}>
      <S.Heading variant="h4">{title}</S.Heading>

      {notice && (
        <div>
          <S.DetailsSectionNotice>{notice}</S.DetailsSectionNotice>
          {headerItem}
        </div>
      )}
      {children && <S.TextContainerGrid variant="body1">{children}</S.TextContainerGrid>}
    </S.DetailsSection>
  </Grid>
);

export default DetailsSection;
